<template>
    <div 
        class="p-modal"
        :class="{ 'is-active': state }"
        v-if="state"
    >
        <div class="p-modal__inner">
            <div class="p-modalContent o-recruit-memberModal ">
                <picture class="o-recruit-memberModal__img">
                    <source :srcset="item.modal_img.pc" media="(min-width: 1025px)"/>
                    <source :srcset="item.modal_img.tab" media="(min-width: 768px)"/>
                    <img :src="item.modal_img.sp" :alt="item.name">
                </picture>
                <div class="o-recruit-memberModal__textArea">
                    <h4 class="o-recruit-memberModal__name">{{ item.name }}
                        <a v-if="item.twitter_url"
                            :href="item.twitter_url"
                            class="o-recruit-memberModal__twitter"
                        ><span></span></a>
                    </h4>
                    <p class="o-recruit-memberModal__job">{{ item.department_text }}チーム</p>
                    <p class="o-recruit-memberModal__school" v-if="item.school">出身学校：{{ item.school }}</p>
                    <p class="o-recruit-memberModal__previousJob" v-if="item.previous_job">前職：{{ item.previous_job }}</p>
                    <dl
                        v-for="(qitem, index) in item.qlist"
                        :key="index"
                        class="o-recruit-memberModal__qblock"
                    >
                        <dt class="o-recruit-memberModal__qttl">{{ qitem.question }}</dt>
                        <dd class="o-recruit-memberModal__qtext">{{ qitem.anser }}</dd>
                    </dl>
                    <div v-if="item.interview_url"
                        class="o-recruit-memberModal__interview u-pcNone"
                    >
                        <a class="c-btn c-btn--outLine" :href="item.interview_url" target="blank_">インタビュー記事を読む</a>
                    </div>
                </div>
                <div v-if="item.interview_url"
                    class="o-recruit-memberModal__interview u-sptabNone"
                >
                    <a class="c-btn c-btn--outLine" :href="item.interview_url" target="blank_">インタビュー記事を読む</a>
                </div>
            </div>
            <button
                class="p-modal__closeBtn"
                @click.prevent="close()">
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            state: Boolean,
            item: Object
        },
        data() {
            return {
                itemData: {},
                currentState: true
            }
        },
        created(){
        },
        methods: {
            setItem(item_data) {

            },
            open() {
            },
            close(e) {
                this.$emit('modalChange', false)
            }
        }
    }
</script>
<style scoped>

</style>